import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'r2e-root',
  imports: [RouterOutlet],
  template: '<router-outlet />'
})
export class AppComponent {}
